import { erpAxios } from '..';

const getClientDocuments = async (id) => {
  const { data } = await erpAxios.get(`/dokumenti/client/${id}`);
  return data;
};

export default getClientDocuments;
